import { RequestDefinition } from 'libraries/front-end-core/core/Api'
import {
  AUTOMATED_DOCUMENTS,
  AUTOMATED_DOCUMENTS_PREPAY,
  CLARILIS_DOCUMENTS,
  DOCUMENT_SECTIONS,
  DOCUMENTS,
  DOCUMENTS_PREPAY,
  DOCUMENTS_SEARCH,
  DOCUMENTS_SEARCH_PREPAY
} from 'constants/requests'
import {
  URL_AUTOMATED_DOCUMENTS,
  URL_AUTOMATED_DOCUMENTS_PREPAY,
  URL_CLARILIS_DOCUMENTS,
  URL_DOCUMENT_SECTIONS,
  URL_DOCUMENTS,
  URL_DOCUMENTS_PREPAY,
  URL_STATIC_DOCUMENTS_METADATA,
  URL_STATIC_DOCUMENTS_METADATA_PREPAY
} from 'constants/urls'
import { toAutomatedDocuments, toClarilisDocuments, toDocuments, toDocumentsSearch, toSections } from './transform'

export const DocumentSections = new RequestDefinition({
  name: DOCUMENT_SECTIONS,
  url: URL_DOCUMENT_SECTIONS,
  transform: toSections
})

export const Documents = new RequestDefinition({
  name: DOCUMENTS,
  url: URL_STATIC_DOCUMENTS_METADATA,
  transform: toDocuments
})

export const DocumentsPrepay = new RequestDefinition({
  name: DOCUMENTS_PREPAY,
  url: URL_STATIC_DOCUMENTS_METADATA_PREPAY,
  transform: toDocuments
})

export const AutomatedDocuments = new RequestDefinition({
  name: AUTOMATED_DOCUMENTS,
  url: URL_AUTOMATED_DOCUMENTS,
  transform: toAutomatedDocuments
})

export const AutomatedDocumentsPrepay = new RequestDefinition({
  name: AUTOMATED_DOCUMENTS_PREPAY,
  url: URL_AUTOMATED_DOCUMENTS_PREPAY,
  transform: toAutomatedDocuments
})

export const ClarilisDocuments = new RequestDefinition({
  name: CLARILIS_DOCUMENTS,
  url: URL_CLARILIS_DOCUMENTS,
  transform: toClarilisDocuments
})

export const DocumentsSearch = new RequestDefinition({
  name: DOCUMENTS_SEARCH,
  url: URL_DOCUMENTS,
  transform: toDocumentsSearch
})

export const DocumentsSearchPrepay = new RequestDefinition({
  name: DOCUMENTS_SEARCH_PREPAY,
  url: URL_DOCUMENTS_PREPAY,
  transform: toDocumentsSearch
})
